<script>
import { isProd } from '@/utils/environment'

// Templates is still under active development - gated to sandbox only for now so it can land
// in production code without being reachable by real clients. Once ready for everyone, this is
// the one place to flip: replace the check below with `true` (or remove the mixin usages).
export default {
  computed: {
    templatesFeatureEnabled() {
      return !isProd()
    }
  }
}
</script>
